import React, { useEffect, useState } from 'react'
import Error404 from 'components/Error404';
import { BASE_URL_OSLOG } from '../../../constants/ActionTypes';

const COMPANY_ID = localStorage.getItem('companyId');
const APIKEY_JYOTI = localStorage.getItem('apikey_jyoti');
const APIKEY_JAVAZ = localStorage.getItem('apiKey');
const USER_ID = localStorage.getItem('user_id');


const EmbeddGanttMonitoring = () => {
    const [URL, setURL] = useState(`${BASE_URL_OSLOG}/embedd-gantt-monitoring?apiKey=${APIKEY_JAVAZ}&apikey_jyoti=${APIKEY_JYOTI}&c=${COMPANY_ID}&uid=${USER_ID}`);
    // const [URL, setURL] = useState(`http://siopas.co.id`);
    const [height, setHeight] = useState(null);
    const [width, setWidth] = useState('100%');

    useEffect(() => {
        const headerHeight = document.getElementById('app-header').clientHeight;
        const bodyHeight = document.body.clientHeight;
        const init = bodyHeight - headerHeight;
        const height = init - 5;
        setHeight(height);
    }, [])

    return (
        <div>
            {
                height !== null && width !== null ?
                <iframe id="frame-embedd" src={URL}
                    style={{
                        width: width,
                        height: `${height}px`,
                    }}
                    allow="fullscreen"
                    scrolling="no" 
                    frameBorder="0"
                ></iframe>
                :
                <Error404 />
            }
        </div>
    )
}

export default EmbeddGanttMonitoring;


// WEBPACK FOOTER //
// ./app/routes/EmbeddGanttMonitoring/index.js